import { render, staticRenderFns } from "./QuestionPad.vue?vue&type=template&id=664fd5f5&scoped=true&"
import script from "./QuestionPad.vue?vue&type=script&lang=js&"
export * from "./QuestionPad.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPad.vue?vue&type=style&index=0&id=664fd5f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664fd5f5",
  null
  
)

export default component.exports